import { BaseListFilter } from '../../../models/base-list-filter.model';
import { SecCodeEnum } from './sec-code.enum';
import { SVBSettlementPriority } from './svb-settlement-priority.enum';
import { SvbV2AchDirectionEnum } from './svb-v2-ach-direction.enum';
import { SvbV2AchStatusEnum } from './svb-v2-ach-status.enum';

export class SvbV2ListFiltersDTO extends BaseListFilter {
  id?: string;
  effectiveEntryDate?: string; // Only show transactions with this effective date and after. Date will be evaluated in PT timezone.
  status?: SvbV2AchStatusEnum;
  svb_account_number?: string;
  amount?: number;
  direction?: SvbV2AchDirectionEnum;
  identification_number?: string;
  receiver_account_type?: string;
  receiver_name?: string;
  receiver_account_number?: string;
  receiver_routing_number?: string;
  settlement_priority?: SVBSettlementPriority;
  batch_id?: string;
  sec_code?: SecCodeEnum;
  company_entry_description?: string;
  fed_trace_number?: string;
  mass_delivery_id?: string;
  isEligible?: boolean;
  platform?: 'cloc' | 'benefit' | 'invoices';
  groupId?: string;
}
